"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSAddWearableComponent = void 0;
const account_service_1 = require("../../shared/services/account.service");
const shared_1 = require("../../shared");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
class CSAddWearableComponent {
    constructor(accountService, genericContentService, addLineService) {
        this.accountService = accountService;
        this.genericContentService = genericContentService;
        this.addLineService = addLineService;
        this.employeeAccount = false;
    }
    ngOnInit() {
        this.getAccountDetails();
    }
    getAccountDetails() {
        this.loader = true;
        this.accountService.getAccountDetails(true).subscribe((accountInfo) => {
            this.loader = false;
            this.prepaidCheck = accountInfo.advancePayAccount;
            this.hasPastDue = accountInfo.pastDueBalance < 0;
            this.employeeAccount = accountInfo.accountType === 'EMPLOYEE' ? true : false;
        });
    }
    addLineEligiblityCall() {
        this.loader = true;
        this.addLineService.getAddLineEligibility()
            .subscribe((data) => {
            this.loader = false;
            this.addLineEligibilityStatus = data;
            this.checkEligibility();
        });
    }
    checkEligibility() {
        var _a, _b, _c;
        this.autoHidePopup = false;
        if ((this.hasPastDue || !((_a = this.addLineEligibilityStatus) === null || _a === void 0 ? void 0 : _a.addWearableLine)) && !this.prepaidCheck && !this.employeeAccount) {
            if (!((_b = this.addLineEligibilityStatus) === null || _b === void 0 ? void 0 : _b.addWearableLine) && !this.hasPastDue) {
                this.autoHidePopup = true;
            }
            this.showToolTipContent();
        }
        else if (!this.hasPastDue && !this.prepaidCheck && ((_c = this.addLineEligibilityStatus) === null || _c === void 0 ? void 0 : _c.addWearableLine)) {
            window.location.href = '/buy/devices/wearable';
        }
        else { // if no conditions met
            this.showToolTipContent();
        }
    }
    onCloseClick() {
        this.tooltip.close();
    }
    showToolTipContent() {
        if (this.hasPastDue === true) {
            this.genericContentService.getGenericContent('/generic/instructional/addLineBlocked').subscribe((data) => {
                this.message = data;
                this.tooltip.open();
            });
        }
        else {
            this.genericContentService.getGenericContent('genericContentBlockAddaline').subscribe((data) => {
                this.message = data;
                this.tooltip.open();
            });
        }
    }
}
exports.CSAddWearableComponent = CSAddWearableComponent;
//# sourceMappingURL=addwearable.component.js.map